import { useState } from "react";
import { useDispatch } from "react-redux";
import { addShift } from "../../stores/member/memberActions";
import Modal from "../Modal";
import i18n from "../../utils/i18n";
import ShiftForm from "./ShiftForm";

const AddShiftButton = ({ event, memberTypeProperties }) => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const handleClick = () => {
    setShowModal(true);
  };

  const handleSubmit = (shift) => {
    const newShift = {
      ...shift,
      members: [],
      preferred_members: [],
    };

    dispatch(addShift(newShift));
    hideModal();
  };

  const hideModal = () => {
    setShowModal(false);
  };

  return (
    <span>
      <button
        type="button"
        onClick={handleClick}
        className="btn btn-primary btn-xs add_shift_button"
      >
        {i18n.t("schedule.shifts.add_shift")}
      </button>
      <Modal
        show={showModal}
        onHide={hideModal}
        title={i18n.t("schedule.shifts.add_shift_header")}
      >
        <ShiftForm
          event={event}
          memberTypeProperties={memberTypeProperties}
          onSubmitHandler={handleSubmit}
        />
      </Modal>
    </span>
  );
};

export default AddShiftButton;
